module.exports = __webpack_public_path__ + "img/baked_alaska_served.85fc49a7.jpg";